import {ChangeDetectorRef, Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {NxBreakpoints, NxViewportService} from "@allianz/ng-aquila/utils";
import {AUTH_USER_KEY, ROLE_INDEX} from "../../utilities/constants";
import {MyStorageService} from "../../services/my-storage.service";
import {PermissionCheckComponent} from "../../models/PermissionCheckComponent";

@Component({
    selector: 'page-show-tool-bar',
    templateUrl: './show-tool-bar.component.html',
    styleUrls: ['./show-tool-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShowToolBarComponent extends PermissionCheckComponent implements OnInit {
  @Input() backSupplier: () => void;
  @Input() editSupplier?: () => void;
  @Input() title: string;

  mobile: boolean = false;

  private readonly _destroyed = new Subject<void>();

  constructor(override myStorageService: MyStorageService,
              public _viewportService: NxViewportService,
              private _cdr: ChangeDetectorRef,) {
    super(myStorageService)
    this._viewportService
      .min(NxBreakpoints.BREAKPOINT_MEDIUM)
      .pipe(takeUntil(this._destroyed))
      .subscribe(isGreaterThanXLarge => {
        this.mobile = !isGreaterThanXLarge;
      });
  }

  ngOnInit(): void {
   this.initPermission();
  }

}
